import Config from "../Config";


import { Fragment, useEffect, useRef, useState } from "react";

import MyRoute from "../helpers/MyRoute";
import MenuTop from "./MenuTop";
import MenuLeft from "./MenuLeft";
import HomeView from "../module/home/HomeView";
import CalculateView from "../module/calculate/CalculateView";
import MainTools from "./MainTools";
import RaportView from "../module/raport/RaportView";
import SettingsView from "../module/settings/SettingsView";
import Info800View from "../module/info800/Info800View";
import FormatDecimal from "../helpers/FormatDecimal";


import delx from "../delx.png";
import PostView from "../module/post/PostView";
import ToolsView from "../module/tools/ToolsView";
import FormatAccount from "../helpers/FormatAccount";
import InputCombo from "../helpers/InputCombo";
import { unescape } from "es-toolkit";


var handleFunction = null;
var handleFunctionParam = null;
var handleActualKeyListener = null;

var sProgressCount = 0;

function MainView(props)
{     
        var startModule = MyRoute( window.location.href, "module" );
        var startView = MyRoute( window.location.href, "view" );
        var startId = MyRoute( window.location.href, "id" );

        if(startModule == null || startModule == undefined) startModule = "home";
        if(startView == null || startView == undefined) startView = "clients";
        if(startId == null || startId == undefined) startId = "-1";

        const [loc, setLoc] = useState({
            menuSelected: startModule,
            viewSelected: startView,
            startId: startId
        });


        const [pushTab, setPush] = useState([]);
        const [pushShow, setPushShow] = useState(0);
        


        const [startRef, setStartRef] = useState(0);


        const defGlobalVar = {           
            trash: [], //koszyk widoczny na stronie (Dla odsetek..)
            trashBank: [], //lista przelewow do wykonania..
        };
        const [globalVariable, setGlobalVariable]  = useState(defGlobalVar);

        const [numRach, setNumRach]= useState(null);
        
 
        const dashboardRef = useRef();

        const mainContentRef = useRef();
       
        const progressRef = useRef();

        const dlgErrorRef = useRef();
        const dlgErrorTitleRef = useRef();
        const dlgErrorMsgRef = useRef();

        const dlgOkRef = useRef();
        const dlgOkTitleRef = useRef();
        const dlgOkMsgRef = useRef();

        const dlgYesNoRef = useRef();
        const dlgYesNoTitleRef = useRef();
        const dlgYesNoMsgRef = useRef();


        const dlgDownloadRef = useRef();
        const dlgDownloadCancelRef = useRef();
        const dlgDownloadOkRef = useRef();
        const dlgDownloadProgressRef = useRef();
        const dlgDownloadInfo0Ref = useRef();
        const dlgDownloadInfoRef = useRef();


        const dlgToastRef = useRef();
        const dlgToastTitleRef = useRef();
    


        const [alertx, setAlertX] = useState(null);
        const [alertx_code, setAlertXCode] = useState('');
        const [alertx_crypt, setAlertXCrypt] = useState('');
        const [alertx_msg, setAlertXMsg] = useState('');


        const [exportSlAccount, setSlAccount] = useState('_x_');
        const [exportTransfer, setExportTransfer] = useState(0);

 

        //------------------------------------------------            

        const changeMenuStatus = (visible) => {
           

              //  dlgErrorRef.current.classList.remove('goHide');
              if(Config.env) console.log("mainView changeMenuStatus ",visible);

              if(visible != undefined && visible.target != null)
              {
                    var isE = dashboardRef.current.classList.contains('fullscreen');

                    if(isE)
                    {
                        dashboardRef.current.classList.remove('fullscreen');
                    }else  dashboardRef.current.classList.add('fullscreen');

              }else 
              {
                if(visible == 1) dashboardRef.current.classList.remove('fullscreen');
                if(visible == 0) dashboardRef.current.classList.add('fullscreen');

              }

                


        }

        //------------------------------------------------
    
        const clickMenu = (item, item2, item3) => {
            
            sessionStorage.setItem("click-action-count", 0); //wyzeruj licznik zbyt duzej ilosci wywołań..
             
            if(Config.env == 'dev') console.log("clickMenu " + item + " " + item2 + " " + item3);

            setLoc( { ...loc , ["menuSelected"]:item, ["viewSelected"]:item2,["startId"]:item3  } );        
            
 


            var url = "";
            if(item != undefined && item.length > 0) url = url + "/module/"+item;
            if(item2 != undefined && item2.length > 0) url = url + "/view/"+item2;      
            if(item3 != undefined && item3.length > 0) url = url + "/p/"+item3;      
            window.history.pushState({page: url}, "", url);  

            props.goRefresh(); 
            

            //scroll to Top webSite
            setTimeout( ()=> { 

                var rightContent = document.getElementsByClassName("econtent");
                if(rightContent.length > 0)
                {
                    console.log("goTop");             

                    window.scrollTo({
                        //'behavior': 'smooth',
                        'behavior': 'auto',
                        'left': 0,
                        'top': rightContent.offsetTop - 0
                      });

                }
                
            }, 200 );

        }        


        const quickGo = (e) => {

            
 
            mainContentRef.current.classList.add('classReloadOut');

            setTimeout( ()=>{
                   mainContentRef.current.classList.add('classClearAnimation');
                   mainContentRef.current.classList.remove('classReloadOut');
            }, 1000 );
          
            

            
            var module = e.target.getAttribute("module");
            var view = e.target.getAttribute("view");
            var id = e.target.getAttribute("id");

            var mTop = e.target.getAttribute("mTop");

            if(module == null )
            {
                if(e.target.parentElement != null)
                {
                     module = e.target.parentElement.getAttribute("module");
                     view = e.target.parentElement.getAttribute("view");
                     id = e.target.parentElement.getAttribute("id"); 
                }
                
            }

            clickMenu(module,view,id);

            if(Config.env == 'dev' )console.log("mtop", mTop, e.target, e.current);
            

            

            if(module == "men")
            {
                changeMenuStatus(0);
            }

            if(module == "home" && view == "start")
            {
                changeMenuStatus(1);
            }
        }

        //------------------------------------------------
        //------------------------------------------------
        window.addEventListener('beforeunload', function(e) {

                    if(Config.env == 'dev') console.log("MainView - window.beforeunload");
                    /*
                    var myPageIsDirty = true; //you implement this logic...
                    if(myPageIsDirty) {
                    //following two lines will cause the browser to ask the user if they
                    //want to leave. The text of this dialog is controlled by the browser.
                    e.preventDefault(); //per the standard
                    e.returnValue = ''; //required for Chrome
                    }
                    //else: user is allowed to leave without a warning dialog
                    */
        });


        window.onpopstate = function(event) 
        {            
                if(event){ 
                     if(Config.env == 'dev')  console.log("MainView - window.onopopstate, goBack or goNext" + event + " ," +window.location );
                }
                else{ 
                     if(Config.env == 'dev')  console.log("MainView - window.onopopstate, clickLink " + event + " ," + window.location);              
                }  


                var moduleX = MyRoute( window.location.href, "module" );               
                var viewX = MyRoute( window.location.href, "view" );
    
                setLoc({...loc, ["menuSelected"]:moduleX, ["viewSelected"]:viewX   });     
                props.goRefresh();      
        }


       
        //------------------------------------------------
        //------------------------------------------------
        //------------------------------------------------        
    
        const showProgressBar = () => {             

               sProgressCount++;

               if(progressRef != null && progressRef.current != undefined )   progressRef.current.classList.remove('goHide');          
        }
        
        const hideProgressBar = () => {            
            
             sProgressCount--;

             if(sProgressCount < 1)
             {
                sProgressCount = 0;
                if(progressRef != null && progressRef.current != undefined  )   progressRef.current.classList.add('goHide');
             }
          
        }

        //------------------------------------------------
        //------------------------------------------------
    
            const writeFilter = (uq_name, val) => {

                    var filterTab = {};        

                    var tmp = sessionStorage.getItem("filter_tab");
                    if(tmp != null && tmp != undefined)
                        {               
                            filterTab = JSON.parse(tmp);                    
                        }                                
            
                    var newTab = {[uq_name]:val}   ;
                    var dt = {...filterTab,...newTab};
                        
                    sessionStorage.setItem('filter_tab', JSON.stringify(dt) );

                // console.log("writeFilter", uq_name, val, dt);
                }
                
                const readFilter = (uq_name, def) => {

                    var filterTab = [];

                    var tmp = sessionStorage.getItem("filter_tab");
                    if(tmp != null && tmp != undefined)
                        {
                            filterTab = JSON.parse(tmp);
                        }

                    if(filterTab[uq_name] != null && filterTab[uq_name] != undefined )    
                        {
                            var tx = filterTab[uq_name];
                            if(tx != undefined && tx != null) return tx;
                        }

                    return def;
                }

        //------------------------------------------------
        //------------------------------------------------

        const showDialog = (title, msg, type, callback, param ) => {

            console.log("show dialog", callback);

            Array.from(document.querySelectorAll('input')).forEach(el => el.blur())

            if(type == 'OK' || type == 'ok')
            {
                     if(dlgOkRef != null && dlgOkRef.current != undefined  ) 
                     {
                          dlgOkRef.current.classList.remove('goHide');
                          dlgOkTitleRef.current.innerHTML = title;
                          dlgOkMsgRef.current.innerHTML = msg;
                     }
            }

            if(type == 'ERROR' || type == 'error')
            {
                     if(dlgErrorRef != null && dlgErrorRef.current != undefined  ) 
                     {
                          dlgErrorRef.current.classList.remove('goHide');
                          dlgErrorTitleRef.current.innerHTML = title;
                          dlgErrorMsgRef.current.innerHTML = msg;
                     }
            }

            if(type == 'YESNO' || type == 'yesno')
            {
                     if(dlgYesNoRef != null && dlgYesNoRef.current != undefined  ) 
                     {
                          dlgYesNoRef.current.classList.remove('goHide');
                          dlgYesNoTitleRef.current.innerHTML = title;
                          dlgYesNoMsgRef.current.innerHTML = msg;                              
                     }
            }

            handleFunction = callback;
            handleFunctionParam = param;
            handleActualKeyListener = window.onkeydown;

            if(Config.env == 'dev') console.log("Dlg keyListener on");
            window.onkeydown = function (e) 
            {                        
                        var code = e.keyCode ? e.keyCode : e.which;    

                        if(Config.env == 'dev') console.log("Dialog listener",code, e.target.nodeName); 

                        if(e.target.nodeName.toLowerCase() == "body" && code == 27)  //esc
                        {
                              closeDialog("none");
                        } 

                        if(e.target.nodeName.toLowerCase() == "body" && code == 84 )  //t
                        {
                              closeDialog("yes");
                        } 

                        if(e.target.nodeName.toLowerCase() == "body" && code == 78 )  //n
                        {
                             closeDialog("no"); 
                        } 

                        if(e.target.nodeName.toLowerCase() == "body" && code == 13 )  //enter
                        {
                             closeDialog("ok"); 
                        } 
            }

            if(Config.env == "dev") console.log("MainView showDialog " + msg);
        }  

     


        const closeDialog = (e) => {

            console.log("close dialog", handleFunction);

             if(dlgErrorRef != null && dlgErrorRef.current != undefined  ) 
             {
                  dlgErrorRef.current.classList.add('goHide');
             }

             if(dlgOkRef != null && dlgOkRef.current != undefined  )   
             {
                dlgOkRef.current.classList.add('goHide');
             }


             if(dlgYesNoRef != null && dlgYesNoRef.current != undefined  ) 
             {  dlgYesNoRef.current.classList.add('goHide');}

             var type = "none";

             if(e != undefined &&  e.target != undefined)
             {
                type = e.target.getAttribute('atr-type');               
             }else 
             {                
                type = e;  //przekazane jako tekst..                 
             }         

            if(Config.env == "dev") console.log("MainView showDialog res:" + type);               

             //oddaj listener..             
             if(handleActualKeyListener != null) window.onkeydown = handleActualKeyListener;             

             if(handleFunction != null)
             {
                    handleFunction(type, handleFunctionParam);
             }
             
        }


        //------------------------------------------------   
    
        const downloadDialog = ( links ) => {
                     
                console.log("Linki", links);

                dlgDownloadInfo0Ref.current.innerHTML = "Trwa pobieranie pliku...";

                dlgDownloadRef.current.classList.remove('goHide');                          
                dlgDownloadCancelRef.current.classList.remove('goHide');                          
                dlgDownloadOkRef.current.classList.add('goHide');                                    

                dlgDownloadProgressRef.current.classList = null;
                dlgDownloadProgressRef.current.classList.add('download_progress_1');  

                var inx = 0;
                var total = -1;
                var actual = -1;

                
                const getFile = () => {

                    if(inx >= links.length) 
                    {                        
                        return;
                    }

                    dlgDownloadInfoRef.current.innerHTML = links[inx].link + "[ " + JSON.stringify(links[inx].params) + " ]";

                    dlgDownloadInfo0Ref.current.innerHTML = "Trwa pobieranie pliku " +  links[inx].fileName + " ...";

                    dlgDownloadRef.current.classList.remove('goHide');                          
                    dlgDownloadCancelRef.current.classList.remove('goHide');                          
                    dlgDownloadOkRef.current.classList.add('goHide');                                    

                    dlgDownloadProgressRef.current.classList = null;
                    dlgDownloadProgressRef.current.classList.add('download_progress_1');  
                    


                        var blob;
                        var xmlHTTP = new XMLHttpRequest();
                        xmlHTTP.open('POST',  Config.master +  links[inx].link , true);


                        xmlHTTP.setRequestHeader("Content-Type", 'application/json');
                        xmlHTTP.setRequestHeader("X-Api-Key",props.userData.apiKey);
                        xmlHTTP.setRequestHeader("_fak_sprzedawcy_id_",props.userData.fak_sprzedawcy_id);
                        xmlHTTP.setRequestHeader("_sec_key_",  Config.genXKey()  );                      
                        xmlHTTP.responseType = 'arraybuffer';

                        xmlHTTP.onload = function(e) {                                                   
 
                            

                        };

                        xmlHTTP.onreadystatechange = function() {
                                                       

                            if (xmlHTTP.readyState == XMLHttpRequest.DONE) {
                                //console.log(this.response);

                                try{

                                     var tab = JSON.parse(this.response);
                                        if(tab["ERROR"])
                                        {
                                            dlgDownloadRef.current.classList.add('goHide');   
                                            showDialog("Ups", "Nie można pobrać pliku (" + this.response + ")", "error", ()=>{}, "" );
                                            return;
                                        }

                                }catch(err) {}                               

                                if(actual < 1)
                                {
                                    dlgDownloadRef.current.classList.add('goHide');   
                                    showDialog("Ups", "Nie można pobrać pliku (" + this.response + ")", "error", ()=>{}, "" );
                                    return;
                                }


                               var blob = new Blob([this.response] );  
                               // var blob = new Blob([this.response], {type: 'application/pdf'} );  
                                console.log(this.response); 

                                var fileName = links[inx].fileName;

                                var url = window.URL.createObjectURL(blob);
                         
                                dlgDownloadProgressRef.current.classList.add('goHide');    
                                dlgDownloadInfoRef.current.classList.add('goHide');    
                                dlgDownloadCancelRef.current.classList.add('goHide');   

                                dlgDownloadInfo0Ref.current.innerHTML = "Pobieranie pliku zostało ukończone ("+ total  +"b)";

                                dlgDownloadOkRef.current.classList.remove('goHide');    
                                dlgDownloadOkRef.current.href = url;
                                //dlgDownloadOkRef.current.href = "data:application/pdf;base64," + btoa( this.response);
                                dlgDownloadOkRef.current.download = fileName;

                                inx++;
                                getFile();
                            }

                            if(total > -1 && actual > -1)
                            {
                                var proc = (100 * actual) / total;
                                if(Config.env == 'dev') console.log("Proc", proc)

                                dlgDownloadProgressRef.current.style.width = proc+"%";                                
                            }
                        }

                        xmlHTTP.onprogress = function(pr) {
                            //pr.loaded - current state
                            //pr.total  - max
                            console.log("Total: " + pr.total);
                            console.log("Loaded: " + pr.loaded);
                            actual = pr.loaded;
                            total = pr.total;
                        };
                        xmlHTTP.onloadend = function(e){
                           
                         
                            
                        }
                        xmlHTTP.send(JSON.stringify(links[inx].params) );

                        dlgDownloadCancelRef.current.onclick = () => {
                            
                            console.log("cancel..");
                            xmlHTTP.abort();

                        }
                    
                }
                
                getFile();

        }

        const downloadCancel = ( links ) => {

                          dlgDownloadRef.current.classList.add('goHide');                          
        }

        //------------------------------------------------   
    
        const keyListener = (e) => {

              var code = e.keyCode ? e.keyCode : e.which;    

              if(Config.env == 'dev') console.log("mainView, keyListener ", code);

                        if(e.shiftKey && e.target.nodeName.toLowerCase() == "body"  ) 
                        {                             
                            if(code == 66 )  clickMenu("home","locks","shortkey"); //b
                            if(code == 70 )  clickMenu("calculate","invoices","shortkey"); //f
                            if(code == 78 )  clickMenu("calculate","nots","shortkey"); //n
                            if(code == 75 )  clickMenu("home","clients","shortkey"); //k
                            if(code == 81 ) 
                            {
                                 showDialog( "Ups!", "Czy na pewno chcesz wyjść z panelu?" , "yesno" ,  (reqP)=>{
                                      if(reqP == "yes")   props.logout();
                                 } );  
                                //q
                            }
                            if(code == 72 )  clickMenu("calculate","history","shortkey"); //history
                            if(code == 80 )  clickMenu("calculate","transfers","shortkey"); //p przelewy
                            if(code == 82 )  clickMenu("calculate","calculate","shortkey"); //r
                            if(code == 83 )  clickMenu("home","services","shortkey"); //s
                            if(code == 85 )  clickMenu("home","contracts","shortkey"); //k
                            if(code >= 49 && code < 58 )  // 1,2,3,4...
                            {
                                var liczba = parseInt(code) - 48;

                                    var hBody = e.target;
                                    const inputElements = hBody.getElementsByTagName('input')
                                    if (inputElements.length > (liczba - 1) ) {
                                        inputElements.item(liczba-1).focus();

                                        e.preventDefault();
                                    }

                                    return false;
                            }
                                
                        }

                        if (e.target.nodeName.toLowerCase() == "body" && code === 13) { //enter                         
                                closeDialog();
                        }else

                        if (e.target.nodeName.toLowerCase() == "body" && code === 38) { //up key                            

                        }else
                        if (e.target.nodeName.toLowerCase() == "body" && code === 40) { //down key

                        }else
                        if(e.target.nodeName.toLowerCase() != "body" && code == 27 )                                                  
                        {
                                //e.target.blur();
                        } else 
                        if(e.target.nodeName.toLowerCase() == "body" && code == 27 )                                                  
                        {
                               // props.onBack();                               
                        } 


        }

        //------------------------------------------------   

          const reqRefresh = () => {
                      
                                var dt = { 
                                    'clock': 1,
                                    'version': Config.app_version,
                                 }
    
                
                                fetch( Config.url + '/rest_v1,refresh', {
                                    method: 'POST', 
                                    body: JSON.stringify(dt), 
                                    headers: {
                                        'Content-Type': 'text/html',
                                        'X-Api-Key': props.userData.apiKey,
                                        '_fak_sprzedawcy_id_': props.userData.fak_sprzedawcy_id,                 
                                        '_sec_key_': Config.genXKey() ,
                                    }
                                })
                                .then(res => res.json() )
                                .then(res => {                                           
                                
                                    

                                    if(res.ERROR != undefined )
                                    {
                                        
                                        if(res.ERROR == 'logout' || res.ERROR == 'LOGOUT')
                                        {
                                            //props.mainView.logout();
                                            localStorage.clear();
                                            sessionStorage.clear();

                                            props.mainView.showDialog("Ups!", "Sesja została zakończona", "ok", (option)=>{

                                                document.location.href = "/?msg=logout";

                                            })
                                        }
                                    }

                                    if(res.status != null && res.status != undefined)
                                    {
    
    
                                           if(   (res.status == 'ask_reload' || res.status == 'ASK_RELOAD')   )
                                            {
                                                
                                            }
    
                                            if(res.status == 'reload' || res.status == 'RELOAD' )
                                            {
                                                window.location.reload();
                                            }
    
                                            if(res.status == 'logout' || res.status == 'LOGOUT')
                                            {
                                                 props.logout();
                                                 window.location.reload();
                                            }

                                            if(res.status == 'OK' || res.status == 'ok' )
                                            {                                                 
                                                var newPush = res.push;
                                                var pushIdLast = readFilter("push_id", "-1");                                                                                      

                                                if(newPush.length > 0)
                                                {                                                                                                     
                                                    var newPushId = newPush[0].id; 

                                                    setPush( JSON.parse(JSON.stringify(newPush)));              

                                                    console.log("XX", pushIdLast, newPushId);
                                                                                              
                                                    if(  ( (pushIdLast+"") !== (newPushId+"") )  )
                                                    {     
                                                         setPushShow(1);                                                                                          
                                                         writeFilter('push_id',  newPushId+"");
                                                    }

                                                   

                                                   
                                                } 

                                            }


                                            if(res.status == 'VERSION' || res.status == 'version')
                                                {

                                                    var ts = new Date() / 1000;

                                                    var lastTs =  readFilter('version_app',  -1 );
                                                    var diffTs = 0;

                                                    if(lastTs > 0)
                                                    {
                                                        diffTs =  parseFloat( ts) -  parseFloat(lastTs) ;
                                                    }

                                                    console.log(lastTs, ts, diffTs);

                                                    if(diffTs  > 120 || diffTs == 0)
                                                    {
                                                            console.log("aktualiacja ");
                                                            showDialog("Potwierdź", "Panel wymaga aktualizacji. Czy chcesz teraz przeładować stronę?", "yesno", (option)=>{
                
                                                                console.log("Res",option);
                                                                ///--------
                                                                if(option == "yes")  window.location.reload();
                                                                //--------
                                                        } );
                                                  }


                                                }
    
                                        
                                    }
                                    
                                } )
                                .catch(err => {
                                    console.log("Err " + err);
                                });                                    
                   
    
       }


        const clearPush = () => {
                      
                                var dt = { 
                                    'clock': 1,
                                    'version': Config.app_version,
                                 }
    
                
                                fetch( Config.url + '/rest_v1,push_clear', {
                                    method: 'POST', 
                                    body: JSON.stringify(dt), 
                                    headers: {
                                        'Content-Type': 'text/html',
                                        'X-Api-Key': props.userData.apiKey,
                                        '_fak_sprzedawcy_id_': props.userData.fak_sprzedawcy_id,                 
                                        '_sec_key_': Config.genXKey() ,
                                    }
                                })
                                .then(res => res.json() )
                                .then(res => {                                           
                                
                                    setPush([]);
                                    
                                } )
                                .catch(err => {
                                    console.log("Err " + err);
                                });                                    
                   
    
       }

        //------------------------------------------------   
        //------------------------------------------------   
 
        const addToTrash = (newItem)=> {

                var trash = globalVariable.trash;
                trash.push(newItem);
                setGlobalVariable({...globalVariable, ['trash']: trash});
        }

        const clearTrash = ()=> {

             
                setGlobalVariable({...globalVariable, ['trash']: [] });
        }

        const approveTrash = () => {

            console.log("approveTrash");  
            clickMenu("calculate","nots","create_from_trash");
              
        }

        

        const delFromTrash = (e) => {

            var inx = e.target.getAttribute('atr-inx');

            var trash = globalVariable.trash;
            var newItems = new Array();

            for(var k=0; k< trash.length; k++)
            {
                if(k == inx) continue;
                newItems.push(trash[k]);
            }

            setGlobalVariable({...globalVariable, ['trash']: newItems });
        }

        //------------------------------------------------
        //------------------------------------------------


        const addToTrashTransfer = (newItem)=> {

                var trash = globalVariable.trashBank;
                trash.push(newItem);
                setGlobalVariable({...globalVariable, ['trashBank']: trash});

                getNumRach();
        }

        const clearTrashTransfer = ()=> {
             
                setGlobalVariable({...globalVariable, ['trashBank']: [] });
        }

        const approveTrashTransfer = () => {

            setExportTransfer(0);
            console.log("approveTrash");                    
            mainView.showProgress();      


              fetch( Config.url + '/rest_v1_calc,ksef_csv', {
                    method: 'POST', 
                    body: JSON.stringify({
                        id: exportSlAccount,
                        items: globalVariable.trashBank,
                    }), 
                    headers: {
                        'Content-Type': 'application/json',                    
                        'X-Api-Key': props.userData.apiKey,
                        '_fak_sprzedawcy_id_': props.userData.fak_sprzedawcy_id,   
                        '_sec_key_': Config.genXKey() ,
                    }
                })
                .then(res => res.text() )
                .then(res => { 

                                mainView.hideProgress(); 
                                
                                var anchor = document.createElement('a');
                                anchor.href = "data:text/csv;charset=utf-8;base64," +  res ;       
                                //anchor.href = "data:text/csv;charset=utf-8;base64," +  window.btoa( unescape(encodeURIComponent( res )) );       
                                anchor.target="_blank";
                                anchor.download = 'plik.csv';
                                anchor.click();

                } )
                .catch(err => {          
                            mainView.showDialog( "Ups!", "I: " + err , "error" , null);
                            mainView.hideProgress();    
                });
        }

        

        const delFromTrashTransfer = (e) => {

            var inx = e.target.getAttribute('atr-inx');

            var trash = globalVariable.trashBank;
            var newItems = new Array();

            for(var k=0; k< trash.length; k++)
            {
                if(k == inx) continue;
                newItems.push(trash[k]);
            }

            setGlobalVariable({...globalVariable, ['trashBank']: newItems });
        }

         const getNumRach = () => {
         
              fetch( Config.url + '/rest_v1_calc,sl_numery_rach', {
                    method: 'POST', 
                    body: JSON.stringify({
                    
                    }), 
                    headers: {
                        'Content-Type': 'application/json',                    
                        'X-Api-Key': props.userData.apiKey,
                        '_fak_sprzedawcy_id_': props.userData.fak_sprzedawcy_id,   
                        '_sec_key_': Config.genXKey() ,
                    }
                })
                .then(res => res.json() )
                .then(res => { 

                      

                            if(res._sys_ == undefined)
                            {
                                mainView.showDialog( "Ups!", "No correct response from server" , "error" , null);  
                            }else
                            if(res.status != undefined && res.status == 'ERROR'  && res.result != undefined )
                            {
                                mainView.showDialog( "Ups!", JSON.stringify(res.result) , "error" , null);  
                            }else    
                            {
                                   setNumRach(res.result);  
                                   
                                   if(res.result.length > 1)
                                   {
                                     //exportSlAccount
                                     setSlAccount( res.result[1].v );
                                     //console.log("Def rach",  res.result[1]);
                                   }
                                   
                            }
                } )
                .catch(err => {          
                            mainView.showDialog( "Ups!", "I: " + err , "error" , null);
                            
                });
        }
        //------------------------------------------------
        //------------------------------------------------

        const toast = (msg) => {


               if(dlgToastRef != null && dlgToastRef.current != undefined  ) 
                     {
                          dlgToastRef.current.classList.remove('goHide');                  
                          dlgToastTitleRef.current.innerHTML = msg;


                          setTimeout(()=>{
                                dlgToastRef.current.classList.add('goHide');   
                          },1500);

                     }

        }

        //------------------------------------------------
        //------------------------------------------------


        var mainView = {   
           
            menuSelected: loc.menuSelected,
            viewSelected: loc.viewSelected,
            idSelected: loc.startId,
           
            changeMenuStatus: changeMenuStatus,

            clickMenu: clickMenu,
            quickGo: quickGo, 


            changeProfile: (cId)=>{ props.changeProfile(cId); setGlobalVariable(defGlobalVar); },


            showProgress: showProgressBar,
            hideProgress: hideProgressBar,

            writeFilter: writeFilter,
            readFilter: readFilter,

            showDialog: showDialog,
            downloadDialog: downloadDialog,

            keyListener: keyListener,

            addToTrash: addToTrash, 
            clearTrash: clearTrash, 

            addToTrashTransfer: addToTrashTransfer, 
            clearTrashTransfer: clearTrashTransfer, 

            toast: toast, 

            vars: globalVariable,


        }



        var content         = "Wybierz opcje z menu";     
        var dialog          = null;
        var dialogProgress  = null;


        switch(loc.menuSelected)
        {
            case 'home': 
            {
                content = <HomeView userData={props.userData} mainView={mainView}  keyListener={keyListener}  />
            }break;

            case 'calculate': 
            {
                content = <CalculateView userData={props.userData} mainView={mainView} keyListener={keyListener}   />
            }break;

            case 'raport': 
            {
                content = <RaportView userData={props.userData} mainView={mainView} keyListener={keyListener}   />
            }break;

            case 'settings': 
            {
                content = <SettingsView userData={props.userData} mainView={mainView} keyListener={keyListener}   />
            }break;

            case 'info800': 
            {
                content = <Info800View userData={props.userData} mainView={mainView} keyListener={keyListener}   />
            }break;

             case 'post': 
            {
                content = <PostView userData={props.userData} mainView={mainView} keyListener={keyListener}   />
            }break;

            case 'tools':
            {
                content = <ToolsView userData={props.userData} mainView={mainView} keyListener={keyListener}   />
            }break;

        }

 
        //-----------------------------------------------------
       


        //-----------------------------------------------------
        //-----------------------------------------------------

        useEffect( ()=>{

           
            if(startRef == 0)
            {
                setStartRef(1);
                if(Config.env == 'prod')  setInterval( reqRefresh, 1500 );
                if(Config.env == 'dev')  setInterval( reqRefresh, 5000 );

              
            }

            if(Config.env == "dev") console.log("MainView.js, listener on");
                window.onkeydown = keyListener;

                return () => {          
                    if(Config.env == "dev") console.log("MainView.js, listener off");      
                    window.onkeydown = null;
                };

        } );

        //-----------------------------------------------------        

        console.log("Global", globalVariable);
        var trashSum = 0;

        for(var trh =0 ; trh < globalVariable.trash.length; trh++)
        {
             trashSum = parseFloat(  globalVariable.trash[trh].roz.ods.kwota_odsetek ) + parseFloat(trashSum);
        }


        var trashSum2 = 0;

        for(var trh =0 ; trh < globalVariable.trashBank.length; trh++)
        {
             trashSum2 = parseFloat(  globalVariable.trashBank[trh].kwota) + parseFloat(trashSum2);
        }


        //-----------------------------------------------------        

    return (
            <div className={ "dashboard classFaceIn " } ref={dashboardRef}>                     


           



                    <MenuLeft userData={props.userData}  mainView={mainView}   />

                    <div className="mainContent" ref={mainContentRef}  >                  
                        {content}
                    </div>

                    <MenuTop  userData={props.userData} mainView={mainView} logout={props.logout}  />

                    <div onClick={props.logout}>logout</div>



                    <div className="dlg_window shadowx z-max goHide dlg_sys" ref={dlgDownloadRef}>
                            <div className="dlg_title" >Menadżer Pobierania</div>
                            <div className="dlg_msg">
                                  <div  ref={dlgDownloadInfo0Ref}>
                                      Trwa pobieranie pliku...
                                  </div>
                                  <br/>
                                  <div ref={dlgDownloadInfoRef}>...</div>
                                  <br/>
                                  <div className="download_bar">
                                        <div className="download_progress_1" ref={dlgDownloadProgressRef}></div>
                                  </div>
                            </div>
                            <div className="dlg_btn">
                                <div className="btn goHide" atr-type="yes" onClick={downloadCancel} ref={dlgDownloadCancelRef}>Przerwij</div>                             
                                <a href="" className="btn goHide" atr-type="yes" onClick={downloadCancel} ref={dlgDownloadOkRef}>Gotowe - zapisz na komputerze</a>                             
                            </div>
                    </div>

                   

                     
                    <div className="progressAnime  goHide "   ref={progressRef}>
                        czekaj...
                    </div>
                 



                    <div className="dlg_window shadowx bg_error z-max goHide dlg_sys" ref={dlgErrorRef}>
                            <div className="dlg_title" ref={dlgErrorTitleRef}>....</div>
                            <div className="dlg_msg" ref={dlgErrorMsgRef}>.a..</div>
                            <div className="dlg_btn">
                                <div className="btn" atr-type="ok" onClick={closeDialog}>Zamknij [enter]</div>                        
                            </div>
                    </div>

                    <div className="dlg_window shadowx z-max goHide dlg_sys " ref={dlgOkRef}>
                                <div className="dlg_title" ref={dlgOkTitleRef}>...</div>
                                <div className="dlg_msg" ref={dlgOkMsgRef}>.b..</div>
                                <div className="dlg_btn">
                                    <div className="btn" atr-type="ok" onClick={closeDialog}>OK [enter]</div>
                                </div>
                        </div>



                    <div className="dlg_window shadowx z-max goHide dlg_sys" ref={dlgYesNoRef}>
                            <div className="dlg_title" ref={dlgYesNoTitleRef}>....</div>
                            <div className="dlg_msg" ref={dlgYesNoMsgRef}>..c..</div>
                            <div className="dlg_btn">
                                <div className="btn" atr-type="yes" onClick={closeDialog}>Tak [t]</div>
                                &nbsp; &nbsp;
                                <div className="btn" atr-type="no" onClick={closeDialog}>Nie [n]</div>
                            </div>
                    </div>


                  
                   {
                        globalVariable.trash.length > 0 &&
                        <Fragment>

                                <div className="trash_sys">
                                        <div className="gobold">
                                            <span className="btn" onClick={approveTrash}>wystaw noty</span> 
                                            &nbsp; &nbsp; 
                                             W koszyku: <FormatDecimal value={trashSum} /> 
                                        </div>
                                        <div className="trash_items">
                                                <table className="table">
                                                    <tbody>
                                                    {
                                                        globalVariable.trash.map ( (trItem, trInx) => {

                                                            var nKlient = trItem.klient.nazwa;
                                                            if(nKlient.length > 30) nKlient = nKlient.substring(0,30)+"...";

                                                            return <tr key={trInx}>
                                                                 <td className="goleft"> {nKlient} </td>
                                                                 <td className="goleft"> {trItem.opis} </td>
                                                                 <td className="goright"><FormatDecimal value={trItem.roz.ods.kwota_odsetek} /></td>
                                                                 <td className="gocenter"> <img src={delx}  className="link_normal" atr-inx={trInx} onClick={delFromTrash} /> </td>
                                                            </tr>
                                                        } )
                                                    }
                                                    </tbody>
                                                </table>
                                        </div>                                                                        
                                </div>

                        </Fragment>
                   }



                     {
                        globalVariable.trashBank.length > 0 &&
                        <Fragment>

                                <div className="trash_sys">
                                        <div className="gobold">                                           
                                            <span className="btn" onClick={ ()=>{setExportTransfer(1);} }>*export .csv</span> 
                                            &nbsp; &nbsp; 
                                             W koszyku: <FormatDecimal value={trashSum2} /> 
                                        </div>
                                        <div>* po exporice csv faktury zostaną oznaczone jako "zapłacone"<br/><br/></div>
                                        <div className="trash_items">                                                
                                                <table className="table">
                                                    <tbody>
                                                    {
                                                        globalVariable.trashBank.map ( (trItem, trInx) => {

                                                            var nKlient = trItem.nazwa;
                                                            if(nKlient.length > 30) nKlient = nKlient.substring(0,30)+"...";

                                                            return <tr key={trInx}>
                                                                 <td className="goleft"> {nKlient} </td>                                                              
                                                                 <td className="goleft"> {trItem.opis}, <FormatAccount value={trItem.numer_rach} />, {trItem.data} </td>
                                                                 <td className="goright gobold"><FormatDecimal value={trItem.kwota} /></td>
                                                                 <td className="gocenter"> <img src={delx}  className="link_normal" atr-inx={trInx} onClick={delFromTrashTransfer} /> </td>
                                                            </tr>
                                                        } )
                                                    }
                                                    </tbody>
                                                </table>                                               
                                        </div>                                                                        
                                </div>

                        </Fragment>
                   }


                   {
                      exportTransfer == '1' &&
                     <div className="dlg_window shadowx z-max dlg_sys"  >
                            <div className="dlg_title" >Exporter przelewów</div>
                            <div className="dlg_msg"  >
                                    <InputCombo items={numRach} value={exportSlAccount} valChange={ (filedName, val, correct, msg) =>{  setSlAccount(val); }  }/>
                            </div>
                            <div className="dlg_btn">
                                <div className="btn" atr-type="yes" onClick={ () => { setExportTransfer(0); } }>anuluj</div>
                                &nbsp; &nbsp;
                                {
                                    exportSlAccount != '_x_' && 
                                    <div className="btn" atr-type="no"  onClick={  approveTrashTransfer } >Pobierz CSV</div>
                                }                               
                            </div>
                    </div>
                   }



                   {
                     pushTab.length > 0 &&
                     <div className="push_msg" onClick={ ()=>{  if(pushShow == '1') { setPushShow('0'); } else setPushShow('1'); } }  >
                           {
                            pushShow == '1' &&  <b  className="link_color">zamknij &nbsp; </b>
                           }

                           {
                            pushShow == '1' &&  <b onClick={()=>{clearPush();} } className="link_color" >usuń wszystkie &nbsp; </b>
                           }
                           &nbsp; Nowe powiadomienia ({pushTab.length})                          
                          {
                            pushShow == '1' &&
                            <div className="push_scroll">
                                <ul>
                                   {
                                        pushTab.map((item, ixP) => {

                                           

                                            return <li key={ixP} className={item.typ} >
                                                <b className="push_title">[{item.created_at}], {item.title}</b>
                                                <div>{item.txt}
                                                     {
                                                        item.param != undefined && item.param.length > 0 &&
                                                        <div>{item.param}</div>
                                                        
                                                     }
                                                     {
                                                        item.progress != undefined && item.progress != '-1' &&
                                                        <div className="progressBarPush">
                                                            {
                                                                item.progress != '100' &&    <div className="progressBarX" style={{width: item.progress+'%' }}></div>
                                                            }
                                                            {
                                                                item.progress == '100' &&    <div className="progressBarX100" style={{width: item.progress+'%' }}></div>
                                                            }
                                                        </div>
                                                     }
                                                </div>
                                            </li>
                                        })
                                   }
                                </ul>
                            </div>   
                                               
                        }
                      
                    </div>
                   }


                    <div className="dlg_toast goHide  " ref={dlgToastRef}>
                            <div className="toast_msg" ref={dlgToastTitleRef}></div>
                    </div>


            </div>
    )

}

export default MainView;


